import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Home from 'src/views/Home'; // 非路由懒加载组件
import Login from 'src/views/Login'; // 登录页面
import Register from 'src/views/Register'; // 注册页面

// 懒加载组件
const About = lazy(() => import('src/views/components/About'));
const BrowseList = lazy(() => import('src/views/BrowseList'));
const Profile = lazy(() => import('src/views/Profile'));
const Message = lazy(() => import('src/views/Message'));
const MyPublish = lazy(() => import('src/views/components/MyPublish'));
const Publish = lazy(() => import('src/views/Publish'));
const DemandSupply = lazy(() => import('src/views/DemandSupply'));
const Settings = lazy(() => import('src/views/components/Settings'));
const PublishDetail = lazy(() => import('src/views/components/PublishDetail'));
const SupplyDetail = lazy(() => import('src/views/components/SupplyDetail'));
const ShareFav = lazy(() => import('src/views/components/ShareFav'));
const SellerDetail = lazy(() => import('src/views/components/SellerDetail'));
const VisitorRecord = lazy(() => import('src/views/components/VisitorRecord'));
const BrowseStats = lazy(() => import('src/views/components/BrowseStats'));
const NoticeDetail = lazy(() => import('src/views/components/NoticeDetail'));

export default function ProjectRouter() {
  return (
    // 路由懒加载中渲染fallback指定的组件
    <Suspense fallback={null}>
      <Routes>
        {/* 重定向 */}
        <Route path='/' element={<Navigate replace to='/login' />} />

        {/* 登录和注册页面 */}
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />

        {/* 主要页面 */}
        <Route path='/home' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/browse-list' element={<BrowseList />} />
        <Route path='/visitor-record' element={<VisitorRecord />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/message' element={<Message />} />
        <Route path='/my-publish' element={<MyPublish />} />
        <Route path='/publish' element={<Publish />} />
        <Route path='/publish-detail/:id' element={<PublishDetail />} />
        <Route path='/detail/:id' element={<SupplyDetail />} />
        <Route path='/demand-supply' element={<DemandSupply />} />
        <Route path='/settings' element={<Settings />} />
        <Route path='/share-fav' element={<ShareFav />} />
        <Route path='/seller-detail/:id' element={<SellerDetail />} />
        <Route path='/browse-stats/:id' element={<BrowseStats />} />
        <Route path='/notice-detail/:id' element={<NoticeDetail />} />
      </Routes>
    </Suspense>
  );
}
